var map = {
	"./decidim/avatar-multiuser.png": 35300,
	"./decidim/brands/google.svg": 68267,
	"./decidim/cc-badge.png": 49510,
	"./decidim/decidim-logo.svg": 63334,
	"./decidim/default-avatar.svg": 51202,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 15142,
	"./decidim/icons.svg": 6325,
	"./decidim/pattern.png": 29570,
	"./decidim/placeholder-card-g.svg": 65551,
	"./decidim/placeholder-card-l.svg": 4724,
	"./decidim/placeholder.jpg": 57899,
	"./decidim/remixicon.symbol.svg": 84611,
	"./decidim/vendor/leaflet/layers-2x.png": 24454,
	"./decidim/vendor/leaflet/layers.png": 1917,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 56644,
	"./decidim/vendor/leaflet/marker-icon.png": 19139,
	"./decidim/vendor/leaflet/marker-shadow.png": 27960,
	"./decidim/vendor/social-share-button/douban.svg": 65906,
	"./decidim/vendor/social-share-button/email.svg": 62255,
	"./decidim/vendor/social-share-button/facebook.svg": 69713,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 60899,
	"./decidim/vendor/social-share-button/hacker_news.svg": 4899,
	"./decidim/vendor/social-share-button/linkedin.svg": 60895,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 54328,
	"./decidim/vendor/social-share-button/pinterest.svg": 52609,
	"./decidim/vendor/social-share-button/reddit.svg": 78193,
	"./decidim/vendor/social-share-button/telegram.svg": 78280,
	"./decidim/vendor/social-share-button/tumblr.svg": 25535,
	"./decidim/vendor/social-share-button/twitter.svg": 87326,
	"./decidim/vendor/social-share-button/vkontakte.svg": 46272,
	"./decidim/vendor/social-share-button/wechat.svg": 9195,
	"./decidim/vendor/social-share-button/whatsapp.svg": 47395,
	"./decidim/vendor/social-share-button/x.svg": 23207,
	"./decidim/vendor/social-share-button/xing.svg": 30417
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62609;